import { getPimToken } from '@api/base/index.js';

// 获取图片大小 重复过滤
export const _getImageSize = (_resolve, _reject, _getSize, msg = '获取失败') => {
  let _size = _getSize();
  if (_size === -1) {
    setTimeout(() => {
      _getImageSize(_resolve, _reject, _getSize, msg);
    }, 2e3)
  } else {
    if (_size === 0) {
      _reject(msg);
    }
    _resolve(_size);
  }
};

const imageSizes = {
  state: () => ({
    imageSizes: {},
    pimToken: null
  }),
  mutations: {
    cachePushImageSize(state, data) {
      state.imageSizes[data.url] = data.size
    },
    setPimToken(state, token) {
      state.pimToken = token;
    },
  },
  actions: {
    cacheImageFileSize({ commit }, payload) {
      commit('cachePushImageSize', payload)
    },
    async getPimToken({ commit, state }) {
      if (state.pimToken) return console.log("已加载过pimToken");
      const res = await getPimToken();
      const data = res?.data || {}
      const token = {
        appKey: data.appKey,
        accessToken: data.accessToken,
        userId: data.userId,
      };
      commit("setPimToken", token);
    },
  },
  getters: {
    imageCacheSizes(state) {
      return state.imageSizes
    },
    imagePimToken(state) {
      return state.pimToken
    },
  }
}

export default imageSizes
